module.exports = __webpack_public_path__ + "img/BlackVintageCar.272d4b99.jpg";